/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs.js'
import * as ConvoDefs from '../convo/defs.defs.js'

const $nsid = 'chat.bsky.group.defs'

export { $nsid }

type LinkEnabledStatus = 'enabled' | 'disabled' | l.UnknownString

export type { LinkEnabledStatus }

const linkEnabledStatus = /*#__PURE__*/ l.string<{
  knownValues: ['enabled', 'disabled']
}>()

export { linkEnabledStatus }

type JoinRule = 'anyone' | 'followedByOwner' | l.UnknownString

export type { JoinRule }

const joinRule = /*#__PURE__*/ l.string<{
  knownValues: ['anyone', 'followedByOwner']
}>()

export { joinRule }

type JoinLinkView = {
  $type?: 'chat.bsky.group.defs#joinLinkView'
  code: string
  enabledStatus: LinkEnabledStatus
  requireApproval: boolean
  joinRule: JoinRule
  createdAt: l.DatetimeString
}

export type { JoinLinkView }

const joinLinkView = /*#__PURE__*/ l.typedObject<JoinLinkView>(
  $nsid,
  'joinLinkView',
  /*#__PURE__*/ l.object({
    code: /*#__PURE__*/ l.string(),
    enabledStatus: /*#__PURE__*/ l.ref<LinkEnabledStatus>(
      (() => linkEnabledStatus) as any,
    ),
    requireApproval: /*#__PURE__*/ l.boolean(),
    joinRule: /*#__PURE__*/ l.ref<JoinRule>((() => joinRule) as any),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { joinLinkView }

type JoinLinkPreviewView = {
  $type?: 'chat.bsky.group.defs#joinLinkPreviewView'
  code: string
  name: string
  owner: ActorDefs.ProfileViewBasic
  memberCount: number
  memberLimit: number
  requireApproval: boolean
  joinRule: JoinRule
  enabledStatus: LinkEnabledStatus

  /**
   * Present only if the request is authenticated and the user is a member of the group.
   */
  convo?: ConvoDefs.ConvoView
  viewer?: JoinLinkViewerState
}

export type { JoinLinkPreviewView }

const joinLinkPreviewView = /*#__PURE__*/ l.typedObject<JoinLinkPreviewView>(
  $nsid,
  'joinLinkPreviewView',
  /*#__PURE__*/ l.object({
    code: /*#__PURE__*/ l.string(),
    name: /*#__PURE__*/ l.string(),
    owner: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    memberCount: /*#__PURE__*/ l.integer(),
    memberLimit: /*#__PURE__*/ l.integer(),
    requireApproval: /*#__PURE__*/ l.boolean(),
    joinRule: /*#__PURE__*/ l.ref<JoinRule>((() => joinRule) as any),
    enabledStatus: /*#__PURE__*/ l.ref<LinkEnabledStatus>(
      (() => linkEnabledStatus) as any,
    ),
    convo: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ConvoDefs.ConvoView>(
        (() => ConvoDefs.convoView) as any,
      ),
    ),
    viewer: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<JoinLinkViewerState>(
        (() => joinLinkViewerState) as any,
      ),
    ),
  }),
)

export { joinLinkPreviewView }

type JoinLinkViewerState = {
  $type?: 'chat.bsky.group.defs#joinLinkViewerState'
  requestedAt?: l.DatetimeString
}

export type { JoinLinkViewerState }

const joinLinkViewerState = /*#__PURE__*/ l.typedObject<JoinLinkViewerState>(
  $nsid,
  'joinLinkViewerState',
  /*#__PURE__*/ l.object({
    requestedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { joinLinkViewerState }

type JoinRequestView = {
  $type?: 'chat.bsky.group.defs#joinRequestView'
  convoId: string
  requestedBy: ActorDefs.ProfileViewBasic
  requestedAt: l.DatetimeString
}

export type { JoinRequestView }

const joinRequestView = /*#__PURE__*/ l.typedObject<JoinRequestView>(
  $nsid,
  'joinRequestView',
  /*#__PURE__*/ l.object({
    convoId: /*#__PURE__*/ l.string(),
    requestedBy: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    requestedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { joinRequestView }

/** A join request from the perspective of the requester, including enough group context to render the request in a list (e.g. group name, owner, member count). */
type JoinRequestConvoView = {
  $type?: 'chat.bsky.group.defs#joinRequestConvoView'
  convoId: string
  name: string
  owner: ActorDefs.ProfileViewBasic
  memberCount: number
  memberLimit: number
  requestedAt: l.DatetimeString
}

export type { JoinRequestConvoView }

/** A join request from the perspective of the requester, including enough group context to render the request in a list (e.g. group name, owner, member count). */
const joinRequestConvoView = /*#__PURE__*/ l.typedObject<JoinRequestConvoView>(
  $nsid,
  'joinRequestConvoView',
  /*#__PURE__*/ l.object({
    convoId: /*#__PURE__*/ l.string(),
    name: /*#__PURE__*/ l.string(),
    owner: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    memberCount: /*#__PURE__*/ l.integer(),
    memberLimit: /*#__PURE__*/ l.integer(),
    requestedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { joinRequestConvoView }
